import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import { CategoryItem } from "./CategoryItem";

import "./CategoriesList.scss";

export const CategoriesList = ({ onClick, list = [], disabled = false }) => {
  return (
    <div
      className="categories-list"
      role={"group"}
      aria-label={"Choose categories that will be blocked"}
    >
      {_.isEmpty(list) ? (
        <p className="no-results">
          <FormattedMessage id="categories_list_no_results" />
        </p>
      ) : (
        _.map(list, (category) => (
          <CategoryItem
            category={category}
            icon={category.icon}
            key={category.name}
            changeAction={category.changeAction}
            onClick={onClick}
            disabled={disabled}
          />
        ))
      )}
    </div>
  );
};
